import RedeemBox, { RedeemBoxPropTypes } from './RedeemBox';

export { RedeemBoxPropTypes };
export default RedeemBox;
